export const styles = {
  container: {
    position: 'fixed' as const,
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    bgcolor: 'rgba(0,0,0,.8)',
    color: 'white',
    zIndex: 1300,
    display: 'flex',
    flexDirection: 'column' as const,
    overflow: 'hidden', // Strictly no scroll
  },
  header: {
    padding: '8px 16px',
    display: 'flex',
    justifyContent: 'flex-end',
    zIndex: 10,
  },
  body: {
    flex: 1,
    display: 'flex',
    position: 'relative' as const,
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 0, // Critical for nested flex scrolling issues
  },
  navLeft: {
    position: 'absolute' as const,
    left: 16,
    zIndex: 5,
  },
  navRight: {
    position: 'absolute' as const,
    right: 16,
    zIndex: 5,
  },
  mediaWrapper: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center',
    justifyContent: 'center',
    p: 2,
  },
  mediaContent: {
    position: 'relative' as const,
    maxWidth: '100%',
    maxHeight: '95%',
    display: 'flex',
    justifyContent: 'center',
  },
  image: {
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain' as const, // Keeps aspect ratio
    borderRadius: 1,
  },
  thumbnailBox: {
    p: 2,
  },
  loader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute' as const,
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
  },
  loaderColor: {
    color: '#fff',
  },
};
